'use client'

import PropTypes from 'prop-types'
import MUIChip from '@mui/material/Chip'

export const TableClearFilters = ({ onClear, filterCount, sx }) => {
  if (!filterCount) {
    return <div data-testid="TableClearFilters" />
  }

  return (
    <MUIChip
      data-testid="TableClearFilters"
      onDelete={onClear}
      variant="contained"
      color="secondary"
      label={`${filterCount} filter${filterCount !== 1 ? 's' : ''} applied`}
      sx={{ ...sx }}
    />
  )
}

TableClearFilters.propTypes = {
  onClear: PropTypes.func,
  filterCount: PropTypes.number,
  sx: PropTypes.object
}
